import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { TiimePipesModule } from 'tiime-expert-utils';
import { TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { CommonDataApiService } from '@api-services/common-data-api.service';
import { MissionExitMotifCodeEnum } from '@enums/mission-exit-motif-code.enum';
import { Mission } from '@models/mission';
import { MissionMotif } from '@models/mission-motif';
import { MissionMotifLabelPipe } from '@shared-pipes/mission-motif-label/mission-motif-label.pipe';

@Component({
  selector: 'app-company-status',
  standalone: true,
  imports: [CommonModule, TiimeTooltipModule, TiimeIconModule, TiimePipesModule, MissionMotifLabelPipe],
  templateUrl: './company-status.component.html',
  styleUrls: ['./company-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyStatusComponent {
  @Input() initializationInProgress = false;
  @Input({ required: true }) mission: Mission;
  @Input() withIcon = true;
  @Input() withLabel = false;

  readonly missionMotifs$: Observable<MissionMotif[]> = this.commonDataApiService.getMissionMotifs();
  readonly MissionExitMotifCodeEnum = MissionExitMotifCodeEnum;

  constructor(private readonly commonDataApiService: CommonDataApiService) {}
}
